import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import type { CommerceOrderTotals } from "@teqtank/commerce-sdk";
@customElement("teqtank-order-totals")
export class TeqtankOrderTotals extends LitElement {
    @property({ attribute: false }) public accessor totals: CommerceOrderTotals | undefined;
    public static override styles = css`
        :host {
            container-type: inline-size;
            display: block;
        }
        .row {
            display: flex;
            justify-content: space-between;
            padding: 0.45rem 0;
            color: var(--teqtank-color-text-muted, #69736d);
        }
        .total {
            border-top: 1px solid var(--teqtank-color-border, #ded8cf);
            margin-top: 0.5rem;
            padding-top: 1rem;
            color: var(--teqtank-color-text, #18221e);
            font-weight: 800;
            font-size: 1.1rem;
        }
    `;
    protected override render() {
        const t = this.totals;
        return t
            ? html`<div class="row"><span>Subtotal</span><span>${t.subtotal.formatted}</span></div>
                  <div class="row"><span>Discount</span><span>−${t.discount.formatted}</span></div>
                  <div class="row"><span>Shipping</span><span>${t.shipping.formatted}</span></div>
                  <div class="row"><span>Tax</span><span>${t.tax.formatted}</span></div>
                  <div class="row total"><span>Total</span><span>${t.total.formatted}</span></div>`
            : html``;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        "teqtank-order-totals": TeqtankOrderTotals;
    }
}
